import React, { useEffect } from "react";
import styles from "./Categories.module.css";
import engineer from "../../assets/c1.svg";
import engineer1 from "../../assets/c2.svg";
import engineer2 from "../../assets/c3.svg";
import engineer3 from "../../assets/c4.svg";
import { List } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CategoriesMiddleware from "../../store/Middlewares/CategoriesMiddleware";
import { useDispatch, useSelector } from "react-redux";
import { IMG_URL } from "../../store/Apis";
import dummyImg from "../../assets/dummy.png";

function Categories() {
  const dispatch = useDispatch();

  const category = useSelector((state) => state.CategoriesReducer.CategoryList)

  useEffect(() => {
    getCategories();
  }, []);
  const getCategories = () => {
    dispatch(CategoriesMiddleware.getCategories())
  }
  
  const navigate = useNavigate();
  const { t } = useTranslation();

  const renderItem = (item) => {
    console.log('item',item)
    return (
      <div
        className={styles.button_div}
        onClick={() =>
          navigate("/categories/categoryDetail", { state: item })
        }
      >
        <img src={item?.image ? IMG_URL + item?.image : dummyImg} className={styles.image} />
        <h2 className={styles.tab_heading}> {t(item?.name)}</h2>
      </div>
    );
  };

  return (
    <div className={styles.home_mainContainer}>
      <h1 className={styles.heading}>{t("Categories")}</h1>
      <List
        style={{ width: "100%" }}
        grid={{ xs: 1, sm: 1, md: 3, lg: 3, xl: 4, xxl: 4 }}
        dataSource={category}
        renderItem={renderItem}
      />
    </div>
  );
}

export default Categories;
